import { Navigate, useNavigate } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import Callout from "components/callout/callout"
import { useTranslation } from "react-i18next"
import ProductsList from "@/features/storages/products/productList"
import useStorages from "hooks/useStorages"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import RightSidebar from "components/sidebar/right/RightSidebar"
import { ReactComponent as AddIcon } from "assets/icons/add.svg"
import SectionHeaderActions from "components/layout/sectionHeaderActions"
import Button from "components/inputs/button"
import PageTitle from "features/navigation/pageTitle"
import useAccess from "@/hooks/useAccess"
import { paramGuardStorage } from "@/utils/paramGuard"
import { AccessRole, FormStatus } from "@/types"
import { MainSheetHeaderActions } from "@/components/layout/layoutChrome"

const ProductsPage = () => {

    const { t } = useTranslation()
    const { targetStorageDocId: storageId } = useTargetStorage()
    const navigate = useNavigate()
    
    const { 
        storage,
        storageStatus 
    } = useStorages({ storageId })
    
    const {
        limitToRoles
    } = useAccess({ storageId: storageId || '' })

    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    return (
        <>
            <PageTitle title={t('titleProducts')} />
            <MainSheetHeaderActions>
                { limitToRoles([AccessRole.OWNER, AccessRole.EDITOR]) && (
                    <Button wideOnMobile
                        to={`/storages/${safeStorageId}/products/create`}
                        design={`primary`}>
                        <AddIcon />
                        <span>{t('buttonNewProduct')}</span>
                    </Button>
                )}
            </MainSheetHeaderActions>
            <Section padX={false}>
                <ProductsList storageId={safeStorageId} />
            </Section>
            <RightSidebar storageId={safeStorageId} />
        </>
    )
}

export default ProductsPage

